module.exports = __webpack_public_path__ + "img/iocn-3.35853dc0.png";